/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import moment from 'moment';
import { Button } from 'antd';
import * as momentRange from 'moment-range';
import { FilterOutlined } from '@ant-design/icons';
import { useMap } from './hook';
import Style, { MapFilters } from './style';

import "leaflet.markercluster/dist/leaflet.markercluster";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import 'leaflet/dist/leaflet.css';

momentRange.extendMoment(moment);

const SubjectsMap = (props) => {
  const {
    filtersOpen,
    setFiltersOpen,
    mapFilters,
    container,
    activeMarker,
    subject,
    mapOptionsButtonsConfig,
  } = useMap(props);
  const { t = (s) => s } = props;

  return (
    <Style className={props.className}>
      <MapFilters
        className="map-focus-filter"
        style={{ display: filtersOpen ? 'flex' : 'none' }}
      >
        <div className="content">{mapFilters}</div>
      </MapFilters>
      <div id="map" ref={container} style={{ height: 472 }}>
        <Button
          style={{ border: 0 }}
          icon={<FilterOutlined />}
          onClick={() => setFiltersOpen((prev) => !prev)}>
          {t('Dashboard::Filter')}
        </Button>
      </div>
      {activeMarker ? subject : null}
      <div className="map-control-buttons">
        {mapOptionsButtonsConfig.map((c, i) => (
          <button onClick={c.handler} key={i.toString()}>
            {c.icon}
          </button>
        ))}
      </div>
    </Style>
  );
}

export default SubjectsMap;
